/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import {
    object, string, shape, bool,
} from 'prop-types';
import mbpLogger from 'mbp-logger';
import Graphql404ErrorProducts from '../../../GraphqlSearchPage/Partials/GraphqlSearchProducts';

import { GRAPHQL_ENV } from '../../../../../gql';
import * as app from '../../../../../../state/ducks/App';
import { setLocale } from '../../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getBestSellersId } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const brandSelectors = app.ducks.brand.selectors;
const appSelectors = app.selectors;

const styles = (theme) => ({
    siteContainer: {
        margin: '0 15px',
        maxWidth: '1400px',
        minWidth: '1000px',
        [theme.breakpoints.up(1430)]: {
            margin: '0 auto',
        },
        [theme.breakpoints.down(600)]: {
            maxWidth: '100%',
            minWidth: '100%',
            margin: '0 auto',
        },
    },
});

const GraphqlProductContainer = ({
    brand, categoryCode, classes, currencyData, productNotAvailable, eventSubType,
}) => {
    const CATEGORY_PRODUCT_QUERY = gql`
    query CategoryProductQuery {
        findCategoryById(brand: "${brand['domain-name']}", environment: "${GRAPHQL_ENV}", id: "${categoryCode}", locale: "${setLocale()}", currency: "${currencyData?.currencyName}" ) {
            products {
                id
                image {
                    altText
                    name
                    snipe
                    snipeImagePath
                    path
                }
                partNumber
                prices {
                    currency
                    type
                    value
                }
                skuPriceRange {
                    sale {
                        value
                    }
                    retail {
                        value
                    }
                }
                name
                brand
                seo {
                    url
                }
                availability {
                    availabilityIndicator
                    deliveryDateType
                    displayEndDate
                    displayStartDate
                    earliestShipDate
                    latestShipDate
                    perishable
                    productDeliveryType
                    shipAlone
                    deliveryMessage
                }
            }
        }
    }
`;

    return (

        <Query query={CATEGORY_PRODUCT_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return <div style={{ height: '80vh' }} />; // prevent header and footer from snapping together
                }

                if (error) {
                    mbpLogger.logError({
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'Graphql404ErrorProductContainer.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: CATEGORY_PRODUCT_QUERY,
                        component: 'Graphql404ErrorProductContainer.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                if (data && data.findCategoryById && data.findCategoryById.products) {
                    const products = data.findCategoryById.products;

                    return (
                        <Grid className={classes.siteContainer}>
                            {products && products.length ? <Graphql404ErrorProducts brand={brand} eventSubType={eventSubType} products={products} productNotAvailable={productNotAvailable} /> : null}
                        </Grid>
                    );
                }
                return null;
            }}
        </Query>

    );
};

GraphqlProductContainer.propTypes = {
    categoryCode: string.isRequired,
    brand: object.isRequired,
    classes: object.isRequired,
    currencyData: shape({
        currencyName: string,
    }).isRequired,
    productNotAvailable: bool,
    eventSubType: string,
};

GraphqlProductContainer.defaultProps = {
    productNotAvailable: false,
    eventSubType: '',
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
    currencyData: appSelectors.getCurrencyData(state),
    categoryCode: getBestSellersId(state),
});

export default connect(mapStateToProps)(withStyles(styles)(GraphqlProductContainer));
